import React from "react";
import "../../stylesheets/screen.css.scss";

function Footer() {
  const date = new Date();
  return (
    <div className="footer" data-testid="footer">
      <div className="footer-body">
        <div className="footer-description">
          ©{date.getFullYear()} Phenom People,Inc All Rights Reserved.
        </div>
      </div>
    </div>
  );
}

export default Footer;
